interface StackType {
  name: string;
  description: string;
  image: string;
}

export const stack: StackType[] = [
  {
    name: "Next JS",
    description: "Современный фреймворк для больших платформ",
    image: "./stack/next.svg",
  },
  {
    name: "React Native",
    description:
      "Фреймворк на основе React, для разработки мобильных приложений на Android и IOS",
    image: "./stack/react.svg",
  },
  {
    name: "TypeScript",
    description: "Строготипизированный язык программирования",
    image: "./stack/typescript.svg",
  },
  {
    name: "After Effects",
    description: "Программа для создания анимированных видео",
    image: "./stack/ae.svg",
  },
  {
    name: "Node JS",
    description: "Кроссплатформенная среда выполнения JavaScript",
    image: "./stack/nodejs.svg",
  },
  {
    name: "Express",
    description: "быстрый, минималистичный и гибкий веб-фреймворк для Node.js",
    image: "./stack/express.svg",
  },
  {
    name: "MongoDB",
    description: "Популярная  NoSQL база данных",
    image: "./stack/mongodb.svg",
  },
  {
    name: "PostgreSQL",
    description: "Cистема управления базами данных с открытым исходным кодом",
    image: "./stack/postgresql.svg",
  },
  {
    name: "Solidity",
    description: "Язык для написания смарт-контрактов и  приложений",
    image: "./stack/solidity.svg",
  },
  {
    name: "Figma",
    description: "Софт для разработки макетов приложений и веб-сайтов",
    image: "./stack/figma.svg",
  },
  {
    name: "GitHub",
    description: "Система контроля версий",
    image: "./stack/github.svg",
  },
  {
    name: "Nginx",
    description: "Высокопроизводительный веб-сервер с открытым исходным кодом",
    image: "./stack/nginx.svg",
  },
  {
    name: "Django",
    description:
      "Высокоуровневый веб-фреймворк на языке программирования Python",
    image: "./stack/django.svg",
  },
  {
    name: "FastAPI",
    description:
      "Высокопроизводительный фреймворк, предназначенный для разработки веб‑сервисов.",
    image: "./stack/fastapi.svg",
  },
  {
    name: "React Redux",
    description: "Система управления глоабльным хранилищем в продуктах",
    image: "./stack/redux.svg",
  },
  {
    name: "Ubuntu",
    description: "Открытая операционная система (ОС) на базе ядра Linux",
    image: "./stack/ubuntu.svg",
  },
  {
    name: "WordPress",
    description:
      "Ьесплатная, гибкая система управления контентом (CMS) с открытым исходным кодом,",
    image: "./stack/wordpress.svg",
  },
];
